import qs from 'qs';
import { newAPI } from '../../../services';

export const fetchLoginStart = async (email, turnstileToken) => {
  const response = await newAPI.post(`/auth/login/start`, qs.stringify({ email, turnstileToken }));
  return response.data;
}

export const fetchLoginPassword = async (loginAttemptToken, password) => {
  const response = await newAPI.post(`/auth/login/password`, qs.stringify({ loginAttemptToken, password }));
  return response.data;
}

export const fetchLoginVerifyCode = async (challengeToken, code) => {
  const response = await newAPI.post(`/auth/login/verify-code`, qs.stringify({ challengeToken, code }));
  return response.data;
}